module.exports = __webpack_public_path__ + "static/banner-20e4b34da446be87ebe5616cc520112f.jpg";